export default function initialSharethis() {
  const target = document.getElementById('shareIt');
  if (target) {
    window.__sharethis__ = null;
    document.body.removeChild(target);
  }
  const scripts = document.createElement('script');
  // scripts.src = 'https://platform-api.sharethis.com/js/sharethis.js#property=59c9111086f25000124ecb07&product=inline-share-buttons';
  scripts.src = '/resources/js/sharethis.js#property=59c9111086f25000124ecb07&product=inline-share-buttons';
  // scripts.async = 'async';
  scripts.id = 'shareIt';
  document.body.appendChild(scripts);
}
